import Marionette from "backbone.marionette";
import $ from "jquery";
import AnimatedRegion from "marionette-animated-region";

import { heapTrack } from "lib/analytics";
import { LOGIN_LEVEL } from "lib/constants";

import components from "../templates/components";
import models from "../models/user";

import SetPasswordView from "./password";
import ForgotPasswordComponent from "./auth/auth-forgot-password";
import LoginComponent from "./auth/auth-login";
import UserHandleComponent from "./auth/auth-handle";

const AuthComponent = Marionette.View.extend({
    template: components.Auth,
    regions: {
        stackContainer: {
            selector: "#stack-container",
            regionClass: AnimatedRegion,
            animation: {
                showAnimation: [
                    {
                        properties: "transition.slideRightBigIn",
                    },
                ],
                hideAnimation: [
                    {
                        properties: "transition.slideRightBigOut",
                    },
                ],
            },
        },
    },
    ui: {
        backBtn: ".btn-back",
        handleContainer: ".handle-component",
        loginContainer: ".login-container",
        passwordContainer: ".password-container",
    },
    events: {
        "click @ui.backBtn": "onBack",
        "click #btn-forgot": "onForgotPassword",
    },
    onForgotPassword(event) {
        event.preventDefault();

        this.showForgotPassword();
    },
    onBack() {
        this.model.unset("auth_type");
        this.model.unset("account_type");

        this.getRegion("stackContainer").empty();
        this.ui.loginContainer.fadeIn("slow");
        $(".close-modal").fadeIn();
        this.ui.backBtn.fadeOut();

        heapTrack("Auth - Back Clicked", { view: this.currentView });
    },
    showStack() {
        this.currentView = "login";

        // if we got a redirect request based on handle submission, but not an sso redirect,
        // process it now
        if (
            this.model.redirectUrl() &&
            this.model.getAuthType() === 0 &&
            !this.model.attributes.authorization_url
        ) {
            setTimeout(() => {
                window.location = this.model.redirectUrl();
            }, 0);
        }

        const view = new LoginComponent({
            model: this.model,
            level: this.options.level,
        });
        this.listenTo(view, "login:forgot", this.showForgotPassword);

        this.showStackView(view);
    },
    showForgotPassword() {
        heapTrack("Auth - Forgot Password Click", {
            enteredHandle: this.handleView.ui.handle.val().length > 0,
            view: this.currentView === "login" ? "login" : "main",
        });

        this.currentView = "forgot";
        this.showStackView(
            new ForgotPasswordComponent({
                model: this.model,
            }),
        );
    },
    showStackView(view) {
        this.ui.loginContainer.hide();
        $(".close-modal").fadeOut();
        this.ui.backBtn.fadeIn();

        this.showChildView("stackContainer", view);
    },
    serializeData() {
        const { phone, email } = this.options;
        let handle = phone || email;

        if (phone && email) {
            handle = window.innerHeight > window.innerWidth ? phone : email;
        }

        return {
            authUser: window.authUser,
            level: this.options.level || 1,
            LOGIN_LEVEL,
            handle,
            handleDesc: handle === phone ? "phone number" : "email address",
            useEmail: this.options.useEmail,
        };
    },
    initialize() {
        if (!this.el) {
            this.el = "#login-modal";
        }
    },
    onRender() {
        this.$el.addClass("auth-component");

        if (!this.options.inline) {
            this.$el.modal({
                closeClass: "icon-close",
                closeText: "&times;",
                fadeDuration: 350,
                fadeDelay: 0,
            });
        }

        this.model = new models.AuthUser({
            redirect: this.options.redirect,
            loginHandle: this.options.loginHandle,
        });

        this.handleView = new UserHandleComponent({
            ...this.options,
            el: this.ui.handleContainer,
            model: this.model,
            showForgotPassword: true,
        });
        this.handleView.render();
        this.listenTo(this.handleView, "success", this.showStack);

        if (this.options.level === LOGIN_LEVEL.RESET) {
            this.showForgotPassword();
        }

        if (window.authUser) {
            new SetPasswordView({
                el: this.ui.passwordContainer,
                reset: this.options.reset,
            }).render();
        }
    },
});

export default {
    AuthComponent,
    SetPasswordView,
    LOGIN_LEVEL,
};
